import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicesIntroduction from "./sections/ServicesIntroduction";
import OurServiceOfferings from "./sections/OurServiceOfferings";
import ReadyToCollaborateCta from "./sections/ReadyToCollaborateCta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicesIntroduction />
      <OurServiceOfferings />
      <ReadyToCollaborateCta />
      <Footer />
    </div>;
}